import { LongRunningTaskModel } from "./types";

export const LONG_RUNNING_TASKS_NOTIFICATION_STATE_KEY =
  "long-running-tasks-notification-state";
export const LONG_RUNNING_TASKS_CHECK_DOWN_SIGNATURE =
  "long-running-tasks-check-down";

export const getLongRunningTasksSignature = (tasks: LongRunningTaskModel[]) => {
  return tasks
    .map((task) => task.task.id)
    .sort((firstTaskId, secondTaskId) =>
      firstTaskId.localeCompare(secondTaskId),
    )
    .join(";");
};

export const getLastNotifiedSignature = () => {
  return localStorage.getItem(LONG_RUNNING_TASKS_NOTIFICATION_STATE_KEY);
};

export const setLastNotifiedSignature = (signature: string) => {
  localStorage.setItem(LONG_RUNNING_TASKS_NOTIFICATION_STATE_KEY, signature);
};

export const clearLastNotifiedSignature = () => {
  localStorage.removeItem(LONG_RUNNING_TASKS_NOTIFICATION_STATE_KEY);
};
